<template>
    <!-- TODO: SLIDER -->
    <!-- Slider main container -->
    <Swiper
        class="w-full h-auto"
        :slides-per-view="4"
        :space-between="50"
        :modules="[Autoplay]"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
        }"
        :loop="true"
    >
        <!-- Additional required wrapper -->
        <!-- <div class="swiper-wrapper"> -->
        <!-- Slides -->
        <SwiperSlide v-for="(sponsor, i) in sponsors" :key="i" class="flex justify-center">
            <img :src="sponsor.image" class="object-center object-contain w-full h-auto" alt="">
        </SwiperSlide>
    </Swiper>
</template>

<script>
    //hook vue
    import { computed, onMounted  } from 'vue'

    //vuex
    import { useStore } from 'vuex'

    // Swiper Slider
    import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue';
    import {Autoplay} from 'swiper';

    
    import "swiper/swiper-bundle.css";
    import "swiper";

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },

        setup() {

            //store vuex
            const store = useStore()

            //onMounted akan menjalankan action "getSponsor" di module "sponsor"
            onMounted(() => {
                store.dispatch('sponsor/getSponsor')
            })

            //digunakan untuk get data state "sponsors" di module "sponsor" 
            const sponsors = computed(() => {
                return store.state.sponsor.sponsors
            })

            return {
                sponsors,   // <-- sponsors
                Autoplay
            }

        }

    }
</script>

<style>

</style>